import React from 'react'

import AnchorsPage from '../components/AnchorsPage'
import { fetchTalentData } from '../data/server/query-transform/fetchTalentData'

const Anchor = ({ pageTitle, title, thumbnail, description, anchors }) => (
  <AnchorsPage pageTitle={pageTitle} title={title} thumbnail={thumbnail} description={description} anchors={anchors} />
)

export async function getServerSideProps(context) {
  return await fetchTalentData({ context })
}

export default Anchor
